import React from 'react';
import { Row, Col } from 'bootstrap';
import classnames from 'classnames';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import { DragSource, DropTarget } from 'react-dnd';
import DraggableTypes from './draggableTypes';
import GlobalElementModalActions from 'flux/actions/GlobalElementModalActions';
import { List } from 'react-virtualized';
import withScrolling from 'react-dnd-scrollzone';
import DoubleConfirmButton from 'shared/components/misc/doubleConfirmButton';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import { WithTooltip } from '@shoflo-rundown/polymer.legacy';
import TooltipConstants from 'shared/constants/TooltipConstants.jsx';
import { isSafari } from 'shared/lib/browserCheck';
import { isGlobalElementManager } from 'main/components/show/cuesheet/cuesheetViewHelper';

const ScrollingVirtualList = withScrolling(List);

/**
 * Row height constant for the `react-virtualized` List
 */
const RVFixedRowHeight = 42;
const RVFixedTitleRowHeight = 62;

/**
 * Number of rows to render for the `react-virtualized` List outside the viewport
 */
const RVOverscanCount = 5;
/**
 * Height of the `react-virtualized` List
 */
const RVListHeight = 500;
/**
 * Width of the `react-virtualized` List
 */
const RVListWidth = 460;

/**
 * Don't scroll to position unless you've passed 15 rows
 */
// const ScrollToOffset = 25;
const ScrollDownOffsetBuffer = isSafari() ? 20 : 5;
const ScrollUpOffsetBuffer = isSafari() ? 5 : 15;

/**
 * The GlobalElementItemsList component (default export)
 */
export default React.createClass({
  displayName: 'GlobalElementItemsList',

  propTypes: {
    items: React.PropTypes.object,
    scrollTo: React.PropTypes.number,
  },

  componentDidUpdate(prevProps) {
    /**
     * `react-virtualized` List component doesn't take `items` as an argument,
     *  so it's not aware of a change. When the `items` change, we force a
     *  render pass by calling this public method
     */
    if (this.props.items !== prevProps.items) {
      this._listRef.wrappedInstance.forceUpdateGrid();
      this._listRef.wrappedInstance.recomputeRowHeights(0);
    }
  },

  getInitialState() {
    return {
      disableScrollToIndex: false,
    };
  },

  render() {
    const { items } = this.props;
    const { disableScrollToIndex } = this.state;

    const rows = items.toArray();

    const listProps = {};

    if (!isGlobalElementManager() && !disableScrollToIndex) {
      listProps.scrollToIndex = this._getTargetScrollTo();
    }

    return (
      <div>
        <ScrollingVirtualList
          {...listProps}
          onScroll={this._handleScroll}
          ref={(ref) => (this._listRef = ref)}
          height={RVListHeight}
          width={RVListWidth}
          overscanRowCount={RVOverscanCount}
          rowCount={items.size}
          rowHeight={({ index }) => {
            return rows[index].get('titleRow')
              ? RVFixedTitleRowHeight
              : RVFixedRowHeight;
          }}
          rowRenderer={this._rowRenderer}
        />
      </div>
    );
  },

  _handleScroll() {
    if (this.state.disableScrollToIndex) return;
    this.setState({ disableScrollToIndex: true });
  },

  _getTargetScrollTo() {
    const { items, scrollTo, scrollDirection } = this.props;

    const rows = items.toArray();

    let targetRowIndex = scrollTo;

    if (scrollTo === rows.length) return targetRowIndex;
    if (scrollTo === 0) return targetRowIndex;

    //Row numbers ar increasing
    if (scrollDirection === 1) {
      targetRowIndex = scrollTo - ScrollDownOffsetBuffer;
    }

    if (scrollDirection === 0) {
      targetRowIndex = scrollTo + ScrollUpOffsetBuffer;
    }

    return targetRowIndex;
  },

  // eslint-disable-next-line react/prop-types, no-unused-vars
  _rowRenderer({ index, isScrolling, key, style }) {
    const { items, onDelete } = this.props;

    const row = items.toArray()[index];

    return (
      <div style={style} key={key}>
        <DroppableListItem
          key={row.get('_id')}
          {...{ row, index, rows: items, onDelete }}
        />
      </div>
    );
  },

  _getItems() {
    const { items } = this.props;

    return items.toArray().map((row, index) => {
      return (
        <DroppableListItem
          key={row.get('_id')}
          {...{ row, index, rows: items }}
        />
      );
    });
  },
});

/**
 * List Item style getter
 */
const getItemStyle = (isOver) => {
  const translateStyle = isOver
    ? { transform: 'translate(0, 14px)', zIndex: 10000000 }
    : {};
  return {
    transition: '0.2s cubic-bezier(0.2, 0, 0, 1)',
    ...translateStyle,
  };
};

/**
 * Drop collect function for the ListItem DropTarget
 * @param  {[type]} connect [description]
 * @param  {[type]} monitor [description]
 * @return [type]           [description]
 */
function dropCollect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    isOverCurrent: monitor.isOver({ shallow: true }),
    canDrop: monitor.canDrop(),
    itemType: monitor.getItemType(),
  };
}

/**
 * Drop target function for the ListItem DropTarget
 * @type {Object}
 */
const dropTarget = {
  /* eslint-disable no-unused-vars */
  canDrop(props, monitor) {
    const { item } = props;
    return true;
  },

  drop(props, monitor, component) {
    if (monitor.didDrop()) {
      return;
    }

    const monitorItem = monitor.getItem();

    const itemType = monitor.getItemType();

    /**
     * Handle adding a global element to a show
     * Element was dragged from GE list over to show row list
     */
    if (itemType === DraggableTypes.GEMItem) {
      const { eventId, showId, itemSetListId, itemSetId, row } = monitorItem;

      const { index, rows } = props;

      let afterRowId;

      if (index > 0) {
        afterRowId = props.rows.toArray()[index - 1].get('_id');
      }

      const globalElementParams = {
        eventId,
        showId,
        itemSetListId,
        itemSetId,
        globalElementRowId: row.get('_id'),
        globalElementRow: row,
      };

      GlobalElementModalActions.addGlobalElementItemRowBelow(
        globalElementParams,
        afterRowId,
      );
    } else if (itemType === DraggableTypes.ShowItem) {
      /**
       * Handle re-ordering show rows
       * Show rows have been re-ordered
       */
      const { index } = props;

      GlobalElementModalActions.reorderShowRows(
        monitorItem.row.get('_id'),
        index,
      );
    }
  },
  /* eslint-enable no-unused-vars */
};

/**
 * Drag source object for List Item DragSource
 * @type {Object}
 */
const listItemDragSource = {
  beginDrag: ({ row, index }) => {
    return { row, index };
  },
};

/**
 * Drag collect function for the List Item DragSource
 * @param  {[type]} connect [description]
 * @param  {[type]} monitor [description]
 * @return [type]           [description]
 */
const dragCollect = (connect, monitor) => {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  };
};

/**
 * ListItem component
 */
const ListItem = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    row: React.PropTypes.object,
    index: React.PropTypes.number,
    connectDropTarget: React.PropTypes.func,
    connectDragSource: React.PropTypes.func,
    isOver: React.PropTypes.bool,
    isDragging: React.PropTypes.bool,
    onDelete: React.PropTypes.func,
  },

  render() {
    const {
      row,
      // index,
      connectDropTarget,
      connectDragSource,
      isOver,
      isDragging,
    } = this.props;

    const item = row.get('item');
    const titleRow = row.get('titleRow');
    const globalElement = row.get('globalElement');
    // const rowId = row.get('_id');

    const containerStyle = {};
    if (isOver) {
      containerStyle.backgroundColor = '#F4EFFE';
    } else {
      containerStyle.backgroundColor = 'inherit';
    }

    if (isDragging) {
      containerStyle.opacity = 0.3;
    }

    return connectDragSource(
      connectDropTarget(
        <div
          className={classnames('ge-insert-item-color-itemlist', {
            'ge-insert-item-color-itemlist-title-row': titleRow,
          })}
          style={containerStyle}
        >
          <div style={getItemStyle(isOver)} className="ge-insert-item-color">
            <Row className={'ge-insert-modal-col-item'}>
              {this._getItem(item, titleRow, globalElement, isDragging)}
            </Row>
          </div>
        </div>,
      ),
    );
  },

  _getItem(item, titleRow, globalElement, isDragging) {
    // const { onDelete } = this.props;

    return (
      <Col lg={24} md={24} sm={24}>
        <div
          className={classnames('ge-insert-modal-col-item-value indx', {
            'global-element-row-item': globalElement,
          })}
        >
          {item.get('numberAdjusted')}
        </div>
        {this._getNameNode(item, titleRow, globalElement)}
        {isDragging ? null : (
          <WithTooltip
            delay={1000}
            tip={TooltipConstants.DeleteRowFromShow}
            placement="top"
          >
            <div className="ge-insert-modal-col-item-delete-wrapper">
              <DoubleConfirmButton
                classes="ge-insert-modal-col-item-delete"
                confirmClass="ge-insert-modal-col-item-delete-confirm"
                beforeIcon={<Icon name="trash" />}
                confirmText="Really delete row?"
                onFirstClick={() => {}}
                onSecondClick={this._handleDelete}
              />
            </div>
          </WithTooltip>
        )}
      </Col>
    );
  },

  _getNameNode(item, titleRow, globalElement, isDragging) {
    const style = isDragging ? { color: 'white', paddingLeft: '28px' } : {};

    return (
      <div
        style={style}
        className={classnames(
          'ge-insert-modal-col-item-value',
          { 'title-row-item': titleRow },
          { 'global-element-row-item': globalElement },
        )}
      >
        {item.get('title') || 'Item'}
      </div>
    );
  },

  _handleDelete() {
    const { row, onDelete } = this.props;
    onDelete(row.get('_id'));
  },
});

const DraggableListItem = DragSource(
  DraggableTypes.ShowItem,
  listItemDragSource,
  dragCollect,
)(ListItem);
const DroppableListItem = DropTarget(
  [DraggableTypes.GEMItem, DraggableTypes.ShowItem],
  dropTarget,
  dropCollect,
)(DraggableListItem);
